import { render } from "./InputCoordinates.vue?vue&type=template&id=b3d28244"
import script from "./InputCoordinates.vue?vue&type=script&lang=js"
export * from "./InputCoordinates.vue?vue&type=script&lang=js"

import "./InputCoordinates.vue?vue&type=style&index=0&id=b3d28244&lang=scss"
script.render = render

export default script